import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  RowHorizontal,
  Calendar,
  TaskSquare,
  ClipboardText,
  UserAdd,
  CallAdd,
  ExportCurve,
} from "iconsax-reactjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { IconButton, InputAdornment } from "@mui/material";
import MicroModal from "micromodal";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import axios from "axios";
import * as XLSX from "xlsx";

import {
  AddNumberContact,
  GetContactsUnit,
  GetDetailsContacts,
  GetInteractionsModal,
  HistoryCallsUser,
  SearchingHistoryCDR,
  SearchingHistoryCDRVoz,
  ShowActiveCall,
} from "../../actions";

import Typography from "../Typography";
import InputSearch from "../InputSearch/InputSearch";
import Drawer from "../manager-section/Drawer/Drawer";
import ColumnsFilter from "../ModalColumnsFilter";
import FieldContainer from "../FieldContainer/FieldContainer";
import FilterDrawer from "../FilterDrawer";
import SelectTagV2 from "../SelectTagV2/SelectTagV2";
import TableVirtual from "../TableVirtual";
import DetailsVoiceModal from "../modals/NewModals/DetailsVoiceModal/DetailsVoiceModal";

import "./history-calls.css";

import { ReactComponent as UserCall } from "../../build/images/user-call.svg";
import { ReactComponent as Filter } from "../../build/images/teams/filter.svg";
import GOOGLEGBM from "../../build/images/googlegbm-new.svg";
import { ReactComponent as WHATSAPPICON } from "../../build/new-midias-icons/whatsapp.svg";
import { ReactComponent as WHATSAPPVOICEICON } from "../../build/new-midias-icons/whatsapp-voz.svg";
import { ReactComponent as FACEBOOKICON } from "../../build/new-midias-icons/facebook.svg";
import { ReactComponent as INSTAGRAM } from "../../build/new-midias-icons/instagram.svg";
import { ReactComponent as VOZICON } from "../../build/new-midias-icons/voz.svg";
import { ReactComponent as EMAILICON } from "../../build/new-midias-icons/email.svg";
import { ReactComponent as TELEGRAMICON } from "../../build/new-midias-icons/telegram.svg";
import { ReactComponent as TWITTERICON } from "../../build/new-midias-icons/twitter.svg";
import { ReactComponent as LINKEDINICON } from "../../build/new-midias-icons/linkedin.svg";
import { ReactComponent as WEBCHATICON } from "../../build/new-midias-icons/webchat.svg";
import { ReactComponent as SMSICON } from "../../build/new-midias-icons/sms-icon.svg";
import { ReactComponent as TEAMSICON } from "../../build/new-midias-icons/teams.svg";
import { access } from "fs";
import HistoricAlertModal from "../modals/NewModals/HistoricAlertModal";
import { useModalHistoricAlert } from "../../hooks/useModalHistoricAlert";

const { connection_platform } = require("../../services/api");

var gethostname = window.location.hostname;
var pathname = "";
var iplocal = connection_platform.ip_intern;
var port = connection_platform.port_backend_intern;
var checkreply = false;

if (gethostname === "localhost") pathname = iplocal;
else pathname = gethostname;

var ipcurrent = pathname;

if (pathname != connection_platform.ip_intern) {
  ipcurrent = connection_platform.ip_apache_view_extern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_extern;
} else {
  ipcurrent = connection_platform.ip_apache_view_intern;
  ipcurrent = ipcurrent + ":" + connection_platform.port_apache_view_intern;
}

port = localStorage.getItem("port");
pathname = localStorage.getItem("pathname");

const formatSecondsToTime = (seconds) => {
  if (!seconds || isNaN(seconds)) return "00:00:00";
  const h = Math.floor(seconds / 3600)
    .toString()
    .padStart(2, "0");
  const m = Math.floor((seconds % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const s = (seconds % 60).toString().padStart(2, "0");
  return `${h}:${m}:${s}`;
};

const getMediaIcon = (mediaId) => {
  switch (mediaId) {
    case 1:
      return <VOZICON />;
    case 2:
      return <WEBCHATICON />;
    case 3:
      return <EMAILICON />;
    case 4:
      return <FACEBOOKICON />;
    case 5:
      return <WHATSAPPICON />;
    case 6:
      return <INSTAGRAM />;
    case 8:
      return <TELEGRAMICON />;
    case 9:
      return <TWITTERICON />;
    case 10:
      return <LINKEDINICON />;
    case 11:
      return <img src={GOOGLEGBM} alt="Google GBM" width={18} height={18} />;
    case 12:
      return <SMSICON />;
    case 15:
      return <TEAMSICON />;
    case 16:
      return <WHATSAPPVOICEICON />;
    default:
      return "-";
  }
};

function defaultSorting(rowA, rowB, columnId) {
  const objectRowA = rowA.original[columnId].data.toLowerCase();
  const objectRowB = rowB.original[columnId].data.toLowerCase();

  if (objectRowA > objectRowB) return -1;
  if (objectRowB > objectRowA) return 1;

  return 0;
}

function customSorting(rowA, rowB, columnId) {
  const customRowA = rowA.original[columnId].config.customOrder;
  const customRowB = rowB.original[columnId].config.customOrder;

  if (customRowA > customRowB) return -1;
  if (customRowB > customRowA) return 1;
  return 0;
}

function HistoryCalls() {
  const dispatch = useDispatch();

  const LIGHT_COLUMNS = [
    { id: "canal", Header: "Canal", display: true },
    { id: "dataHoraInicio", Header: "Data/Hora Inicio", display: true },
    { id: "dataHoraFim", Header: "Data/Hora Fim", display: true },
    { id: "durRing", Header: "Dur.Ring.", display: true },
    { id: "duracao", Header: "Duração", display: true },
    { id: "nome", Header: "Nome", display: true },
    { id: "chamado", Header: "Chamado", display: true },
    { id: "chamador", Header: "Chamador", display: true },
    { id: "tipo", Header: "Tipo", display: true },
    { id: "situacao", Header: "Situação", display: true },
    { id: "razaoDesconexao", Header: "Razão de desconexão", display: true },
    { id: "agente", Header: "Agente", display: true },
    { id: "protocolo", Header: "Protocolo", display: true },
    { id: "estado", Header: "Estado", display: true },
    { id: "nomeDaEmpresa", Header: "Nome da empresa", display: true },
    { id: "cnpjDaEmpresa", Header: "CNPJ da empresa", display: true },
    {
      id: "codigoExternoDaEmpresa",
      Header: "Código externo da empresa",
      display: true,
    },
  ];
  const tiposOptions = [
    { id: 1, label: "Não Atendidas" },
    { id: 2, label: "Atendidas" },
    { id: 3, label: "Finalizadas" },
    { id: 4, label: "Entrada" },
    { id: 5, label: "Saída" },
  ];
  const canaisOptions = [
    {
      id: 1,
      label: "Voz",
    },
    {
      id: 2,
      label: "Webchat",
    },
    {
      id: 3,
      label: "E-mail",
    },
    {
      id: 4,
      label: "Facebook",
    },
    {
      id: 5,
      label: "WhatsApp",
    },
    {
      id: 6,
      label: "Instagram",
    },
    {
      id: 8,
      label: "Telegram",
    },
    {
      id: 9,
      label: "Twitter",
    },
    {
      id: 10,
      label: "LinkedIn",
    },
    { id: 12, label: "SMS" },
    {
      id: 15,
      label: "Teams",
    },
    {
      id: 16,
      label: "WhatsApp Voz",
    },
  ];
  const startFiltersValues = {
    dataInicio: dayjs(),
    dataFim: dayjs(),
    chamado: "",
    chamador: "",
    palavra: "",
    tipo: tiposOptions,
    canais: [],
  };

  const historyCalls = useSelector((state) =>
    state.historycalls ? state.historycalls.historycalls : [],
  );
  const InfoUsers = useSelector((state) => state.informationusers);
  const infoContact = useSelector((state) => state.infocontact);

  const [search, setSearch] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [totalFilters, setTotalFilters] = useState([]);
  const [columnsConfig, setColumnsConfig] = useState(() => {
    const saved = localStorage.getItem("columns_history_calls");
    if (saved) {
      const columnsSaved = JSON.parse(saved);
      if (
        Array.isArray(columnsSaved) &&
        columnsSaved.length !== LIGHT_COLUMNS.length
      ) {
        localStorage.setItem(
          "columns_history_calls",
          JSON.stringify(LIGHT_COLUMNS),
        );
        return LIGHT_COLUMNS;
      }
      return columnsSaved;
    }
    return LIGHT_COLUMNS;
  });
  const [filtersValues, setFiltersValues] = useState(() => {
    const saved = localStorage.getItem("filters_history_calls");

    if (saved) {
      try {
        const parsedSaved = JSON.parse(saved);

        return {
          ...startFiltersValues,
          tipo: parsedSaved.tipo || tiposOptions,
          canais: parsedSaved.canais || [],
        };
      } catch (e) {
        console.error("Erro ao ler filtros do storage", e);
        return startFiltersValues;
      }
    }

    return startFiltersValues;
  });
  const [value, setValue] = useState(null);
  const [openDataInicio, setOpenDataInicio] = useState(false);
  const [openDataFim, setOpenDataFim] = useState(false);
  const [isApplying, setIsApplying] = useState(false);
  const [infosVoiceModal, setInfosVoiceModal] = useState({});
  const [canaisUserOptions, setCanaisUserOptions] = useState(() => {
    if (InfoUsers.user_midias) {
      return canaisOptions.filter((canal) =>
        InfoUsers.user_midias.includes(canal.id),
      );
    }
    return canaisOptions;
  });
  const { openModal, closeModal, dataToStartCall } = useModalHistoricAlert();

  const handleApplyFilters = () => {
    setIsApplying(true);

    const datainit = filtersValues.dataInicio
      ? filtersValues.dataInicio.format("YYYY-MM-DD")
      : "";
    const datafim = filtersValues.dataFim
      ? filtersValues.dataFim.format("YYYY-MM-DD")
      : "";

    if (!datainit || !datafim) {
      alert("Por favor, preencha a Data Início e a Data Fim.");
      setIsApplying(false);
      return;
    }
    if (filtersValues.dataInicio.isAfter(filtersValues.dataFim)) {
      alert("A Data Início não pode ser maior que a Data Fim.");
      setIsApplying(false);
      return;
    }

    const tiposSelecionados = filtersValues.tipo.map((t) => t.id);

    const naoatendidas = tiposSelecionados.includes(1);
    const atendidas = tiposSelecionados.includes(2);
    const finalizadas = tiposSelecionados.includes(3);
    const entrada = tiposSelecionados.includes(4);
    const saida = tiposSelecionados.includes(5);

    const ocupado = false;
    const livre = false;
    const ring = "";

    const midias = filtersValues.canais.map((c) => c.id).join(",");

    dispatch(
      HistoryCallsUser(
        datainit,
        datafim,
        filtersValues.chamador, // chamador
        filtersValues.chamado, // chamado
        naoatendidas,
        ocupado,
        saida,
        entrada,
        ring,
        atendidas,
        livre,
        midias,
        filtersValues.palavra, // mensagem
        finalizadas,
      ),
    )
      .then(() => {
        setIsApplying(false);
        setOpenDrawer(false);
      })
      .catch((error) => {
        console.error("Erro ao buscar histórico:", error);
        setIsApplying(false);
      });
  };

  const contactWithNumber = (
    rowData,
    isToMakeCallWithoutVerification = false,
  ) => {
    const isToOpenModal =
      connection_platform.isToShowModalInHistoric &&
      !Boolean(rowData.companyname) &&
      !isToMakeCallWithoutVerification;
    if (isToOpenModal) {
      openModal(rowData);
      return;
    }
    let telefone = rowData.iddirection === 2 ? rowData.called : rowData.caller;

    const inputContact = document.getElementsByName("chamado");

    if (inputContact && inputContact.length > 0) {
      inputContact[0].value = telefone;
      inputContact[0].dispatchEvent(new Event("input", { bubbles: true }));

      dispatch(ShowActiveCall("active"));
    }
  };

  const verifyAddUser = (rowData, isToOpenInEditMode = false) => {
    let telefone = rowData.iddirection === 2 ? rowData.called : rowData.caller;

    axios
      .get(
        `${connection_platform.type_connect}://${pathname}:${port}/conn/getcontacts?number=${telefone}&nome=&empresa=&contato=&codext=&email=`,
      )
      .then((response) => {
        if (response.data.length > 0) {
          if (isToOpenInEditMode) {
            dispatch(
              GetDetailsContacts(true, response.data[0], undefined, rowData),
            );
          } else {
            dispatch(GetDetailsContacts(true, response.data[0]));
          }
        } else {
          if (isToOpenInEditMode) {
            dispatch(GetDetailsContacts(true, "", rowData, rowData));
          } else {
            dispatch(GetDetailsContacts(true, "", rowData));
          }
          dispatch(AddNumberContact("", telefone));
        }
      })
      .catch((erro) => {
        // Se der erro na API, cai aqui
        console.error("Erro ao puxar contato1", erro);
      });
  };

  const openDetailsContact = (contactid, rowData = null) => {
    dispatch(GetContactsUnit(contactid))
      .then((dadosDoContato) => {
        // console.log("Entrou aqui", infoContact, dadosDoContato);
        if (dadosDoContato) {
          let contact = dadosDoContato;
          dispatch(GetDetailsContacts(true, contact, undefined, rowData));
        }
      })
      .catch((erro) => {
        console.error("Erro ao puxar contato2", erro);
      });
  };

  const displayModalHistory = (rowData) => {
    const allData = rowData.allData.data;
    let telefone = allData.iddirection === 2 ? allData.called : allData.caller;
    let cdrid = allData.cdrid;
    let midia = allData.idmidia;
    let idgroup = InfoUsers.idgroup;
    //Função que seta o nome e o número do contato pro modal de interações
    dispatch(GetInteractionsModal(allData.contactname, telefone));
    setInfosVoiceModal({
      nome: allData.contactname,
      telefone: telefone,
      data: allData.to_char,
    });
    //

    if (midia !== 1 && midia !== 16) {
      dispatch(SearchingHistoryCDR(telefone, cdrid, idgroup, InfoUsers));
      MicroModal.show("modal__historico-atendimento-contact-2");
    } else if (midia === 1 || midia === 16) {
      dispatch(SearchingHistoryCDRVoz(telefone, cdrid, idgroup));
      MicroModal.show("modal__interacao-voz");
    }
  };

  const renderActions = (rowData) => {
    const allData = rowData.allData.data;

    return (
      <div style={{ display: "flex", gap: "8px" }}>
        <div
          title="Entrar em contato"
          style={{ cursor: "pointer", width: 32, height: 32 }}
          onClick={() => contactWithNumber(allData)}
        >
          <CallAdd variant="Outline" color="#395ABF" />
        </div>

        {!allData.contactid && (
          <div
            title="Adicionar Contato"
            style={{ cursor: "pointer", width: 32, height: 32 }}
            onClick={() => verifyAddUser(allData)}
          >
            <UserAdd variant="Outline" color="#395ABF" />
          </div>
        )}
        {allData.contactid && (
          <div
            title="Informações do Contato"
            style={{ cursor: "pointer", width: 32, height: 32 }}
            onClick={() => openDetailsContact(allData.contactid)}
          >
            <ClipboardText variant="Outline" color="#395ABF" />
          </div>
        )}
        <div
          title="Detalhes do Atendimento"
          style={{ cursor: "pointer", width: 32, height: 32 }}
          onClick={() => displayModalHistory(rowData)}
        >
          <TaskSquare variant="Outline" color="#395ABF" />
        </div>
      </div>
    );
  };

  const exportToExcel = () => {
    if (!memoizedTableData || memoizedTableData.length === 0) {
      alert("Não há dados para exportar.");
      return;
    }

    const getMediaName = (mediaId) => {
      const canais = {
        1: "Voz",
        2: "Webchat",
        3: "E-mail",
        4: "Facebook",
        5: "WhatsApp",
        6: "Instagram",
        8: "Telegram",
        9: "Twitter",
        10: "LinkedIn",
        11: "Google GBM",
        12: "SMS",
        15: "Teams",
        16: "WhatsApp Voz",
      };
      return canais[mediaId] || "-";
    };

    const dataToExport = memoizedTableData.map((row) => {
      const rawData = row.allData.data;

      return {
        Canal: getMediaName(rawData.mediaid),
        Chamador: row.chamador.data,
        Chamado: row.chamado.data,
        Nome: row.nome.data,
        "Data/Hora Início": row.dataHoraInicio.data,
        "Data/Hora Fim": row.dataHoraFim.data,
        Duração: row.duracao.data,
        "Dur. Ring": row.durRing.data,
        Tipo: row.tipo.data,
        Situação: row.situacao.data,
        "Razão de desconexão": row.razaoDesconexao.data,
        Agente: row.agente.data,
        Protocolo: row.protocolo.data,
        Estado: row.estado.data,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Histórico");

    const colWidths = Object.keys(dataToExport[0]).map((key) => ({
      wch: Math.max(key.length, 15),
    }));
    worksheet["!cols"] = colWidths;

    const dataAtual = dayjs().format("DD-MM-YYYY_HH-mm");
    const fileName = `Historico_Atendimentos_${dataAtual}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const refactoredData = (originalData) => {
    const newData = [...originalData];

    return newData.map((item) => ({
      canal: {
        data: getMediaIcon(item.mediaid),
        config: {
          className: "cell-gray-text",
          customData: false,
          read: true,
          customOrder: item.mediaid,
        },
      },
      dataHoraInicio: {
        data: item.to_char || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      dataHoraFim: {
        data: item.dateend || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      durRing: {
        data: formatSecondsToTime(item.duracaoring),
        config: {
          className: "cell-gray-text",
          customData: false,
          read: true,
          customOrder: item.duracaoring,
        },
      },
      duracao: {
        data: formatSecondsToTime(item.duration || item.duracao),
        config: {
          className: "cell-gray-text",
          customData: false,
          read: true,
          customOrder: item.duration || item.duracao,
        },
      },
      nome: {
        data: item.contactname || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      chamado: {
        data: item.called || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      chamador: {
        data: item.caller || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      tipo: {
        data:
          item.directionin === 1
            ? "Receptivo"
            : item.directionin === 2
              ? "Saída"
              : "-",
        config: {
          className: "cell-gray-text",
          customData: false,
          read: true,
          colorTag: item.directionin === 1 ? "green" : "red",
        },
      },
      situacao: {
        data: item.answer ? "Atendido" : "Não Atendido",
        config: {
          className: "cell-gray-text",
          customData: false,
          read: true,
          colorTag: item.answer ? "green" : "red",
        },
      },
      razaoDesconexao: {
        data: item.razao_desc || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      agente: {
        data: item.displayname || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      protocolo: {
        data: item.protocolo || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      estado: {
        data: item.status || "-",
        config: {
          className: "cell-gray-text",
          customData: false,
          read: true,
          colorTag: item.status === "Livre" ? "green" : "yellow",
        },
      },
      allData: {
        data: item || "",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      nomeDaEmpresa: {
        data: item.companyname || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      cnpjDaEmpresa: {
        data: item.companycnpj || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
      codigoExternoDaEmpresa: {
        data: item.companyexterncode || "-",
        config: { className: "cell-gray-text", customData: false, read: true },
      },
    }));
  };

  useEffect(() => {
    localStorage.setItem(
      "columns_history_calls",
      JSON.stringify(columnsConfig),
    );
  }, [columnsConfig]);

  useEffect(() => {
    const filtersToSave = {
      tipo: filtersValues.tipo,
      canais: filtersValues.canais,
    };

    localStorage.setItem(
      "filters_history_calls",
      JSON.stringify(filtersToSave),
    );
  }, [filtersValues.tipo, filtersValues.canais]);

  useEffect(() => {
    handleApplyFilters();
  }, []);

  const memoizedTableData = useMemo(() => {
    if (!historyCalls || historyCalls.length === 0) return [];

    const formattedData = refactoredData(historyCalls);

    if (!search || search.trim() === "") {
      return formattedData;
    }

    const lowerSearch = search.toLowerCase();

    return formattedData.filter((row) => {
      const searchableString = `
        ${row.nome.data} 
        ${row.chamado.data} 
        ${row.chamador.data} 
        ${row.tipo.data} 
        ${row.situacao.data} 
        ${row.razaoDesconexao.data} 
        ${row.agente.data} 
        ${row.protocolo.data} 
        ${row.estado.data}
        ${row.nomeDaEmpresa.data}
        ${row.cnpjDaEmpresa.data}
        ${row.codigoExternoDaEmpresa.data}
      `.toLowerCase();

      return searchableString.includes(lowerSearch);
    });
  }, [historyCalls, search]);

  const memoizedTableColumns = useMemo(() => {
    const baseColProps = {
      canal: {
        accessor: "canal",
        width: 80,
        disableFilters: true,
        sortType: customSorting,
      },
      dataHoraInicio: {
        accessor: "dataHoraInicio",
        width: 180,
        sortType: defaultSorting,
      },
      dataHoraFim: {
        accessor: "dataHoraFim",
        width: 180,
        sortType: defaultSorting,
      },
      durRing: { accessor: "durRing", width: 100, sortType: customSorting },
      duracao: { accessor: "duracao", width: 100, sortType: customSorting },
      tipo: {
        accessor: "tipo",
        width: 120,
        sortType: defaultSorting,
        typeCell: "tagChip",
      },
      situacao: {
        accessor: "situacao",
        width: 140,
        sortType: defaultSorting,
        typeCell: "tagChip",
      },

      estado: {
        accessor: "estado",
        minWidth: 90,
        sortType: defaultSorting,
        typeCell: "tagChip",
      },
      nome: { accessor: "nome", minWidth: 150, sortType: defaultSorting },
      chamado: { accessor: "chamado", minWidth: 120, sortType: defaultSorting },
      chamador: {
        accessor: "chamador",
        minWidth: 120,
        sortType: defaultSorting,
      },
      razaoDesconexao: {
        accessor: "razaoDesconexao",
        minWidth: 200,
        sortType: defaultSorting,
      },
      agente: { accessor: "agente", minWidth: 150, sortType: defaultSorting },
      protocolo: {
        accessor: "protocolo",
        minWidth: 150,
        sortType: defaultSorting,
      },
      nomeDaEmpresa: {
        accessor: "nomeDaEmpresa",
        minWidth: 150,
        sortType: defaultSorting,
      },
      cnpjDaEmpresa: {
        accessor: "cnpjDaEmpresa",
        minWidth: 150,
        sortType: defaultSorting,
      },
      codigoExternoDaEmpresa: {
        accessor: "codigoExternoDaEmpresa",
        minWidth: 150,
        sortType: defaultSorting,
      },
    };

    const dynamicWidths = {};

    if (memoizedTableData.length > 0) {
      memoizedTableData.forEach((row) => {
        Object.keys(baseColProps).forEach((key) => {
          if (baseColProps[key].width) return;

          const cellData = row[key] ? row[key].data : "-";

          if (typeof cellData === "string" || typeof cellData === "number") {
            const textLength = String(cellData).length;
            const calculatedWidth = textLength * 8 + 40;

            if (!dynamicWidths[key] || calculatedWidth > dynamicWidths[key]) {
              dynamicWidths[key] = calculatedWidth;
            }
          }
        });
      });
    }

    return columnsConfig.map((col) => {
      const baseProps = baseColProps[col.id];

      const headerLength = String(col.Header).length * 8 + 60;

      const maxContentWidth = dynamicWidths[col.id] || 0;
      let finalWidth =
        baseProps.width ||
        Math.max(baseProps.minWidth, headerLength, maxContentWidth);

      if (finalWidth > 400) finalWidth = 400;

      return {
        ...col,
        ...baseProps,
        width: finalWidth,
      };
    });
  }, [columnsConfig, memoizedTableData]);

  return (
    <main className="history-calls">
      <div className="history-calls__container">
        <div className="history-calls__container-header">
          <Typography.H4 color={"gray-600"} weight={700}>
            Histórico de atendimentos
          </Typography.H4>
          <div className="history-calls__container-header__options">
            <InputSearch exibIcon search={search} setSearch={setSearch} />
            <div
              className="actions__item-white"
              data-micromodal-trigger="modal-columns"
            >
              <RowHorizontal variant="Outline" />
              <span>Colunas</span>
            </div>
            <div
              className="actions__item"
              onClick={(event) => {
                return setOpenDrawer(true);
              }}
            >
              <Filter />
              <span>Filtros</span>
              {totalFilters.length > 0 && (
                <span className="total-filters">{totalFilters.length}</span>
              )}
            </div>

            {memoizedTableData &&
              memoizedTableData.length > 0 &&
              InfoUsers.permdownload && (
                <div
                  className="actions__item-white big-icon"
                  onClick={() => exportToExcel()}
                  title="Exportar Dados"
                >
                  <ExportCurve variant="Outline" />
                </div>
              )}
          </div>
        </div>
        <div className="history-calls__container-body">
          {memoizedTableData && memoizedTableData.length > 0 ? (
            <TableVirtual
              key={"table-virtual-history-calls"}
              className="table-history-calls"
              data={memoizedTableData}
              columns={memoizedTableColumns}
              fixedHeader
              screen="history_calls"
              rowShadowLine
              renderRowHoverActions={renderActions}
            />
          ) : (
            <div className="empty-state">
              <div className="icon-empty">
                <UserCall />
              </div>
              <div className="texts-empty">
                <div className="title-empty">
                  <Typography.H5 color={"blue-selected-4"} weight={700}>
                    Nenhum registro de atendimento encontrado
                  </Typography.H5>
                </div>
                <div className="subtitle-empty">
                  <Typography.H6 color={"gray-180"} weight={500}>
                    Não localizamos atendimentos que correspondam aos critérios
                    aplicados. Verifique se os termos de busca ou o intervalo de
                    tempo estão corretos.
                  </Typography.H6>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <FilterDrawer
        isOpen={openDrawer}
        isApplying={isApplying}
        onClose={() => setOpenDrawer(false)}
        onApply={handleApplyFilters}
        onClear={() => {
          setFiltersValues(startFiltersValues);
        }}
      >
        <div className="filters-hystory-calls">
          {/* DATA INÍCIO */}
          <FieldContainer title={"Data início"}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                format="DD/MM/YYYY"
                label={null}
                value={filtersValues.dataInicio}
                onChange={(newValue) =>
                  setFiltersValues({ ...filtersValues, dataInicio: newValue })
                }
                open={openDataInicio}
                onClose={() => setOpenDataInicio(false)}
                dayOfWeekFormatter={(_diaEmTexto, diaEmDayjs) => {
                  const diasDaSemana = ["D", "S", "T", "Q", "Q", "S", "S"];
                  return diasDaSemana[diaEmDayjs.day()];
                }}
                maxDate={filtersValues.dataFim}
                slotProps={{
                  textField: {
                    placeholder: "DD/MM/AAAA",
                    onClick: () => setOpenDataInicio(true),
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            edge="start"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenDataInicio(true);
                            }}
                          >
                            <Calendar />
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  },
                  inputAdornment: {
                    style: { display: "none" },
                  },
                }}
              />
            </LocalizationProvider>
          </FieldContainer>

          {/* DATA FIM */}
          <FieldContainer title={"Data fim"}>
            <LocalizationProvider
              dateAdapter={AdapterDayjs}
              adapterLocale="pt-br"
            >
              <DatePicker
                format="DD/MM/YYYY"
                label={null}
                value={filtersValues.dataFim}
                onChange={(newValue) =>
                  setFiltersValues({ ...filtersValues, dataFim: newValue })
                }
                open={openDataFim}
                onClose={() => setOpenDataFim(false)}
                dayOfWeekFormatter={(_diaEmTexto, diaEmDayjs) => {
                  const diasDaSemana = ["D", "S", "T", "Q", "Q", "S", "S"];
                  return diasDaSemana[diaEmDayjs.day()];
                }}
                minDate={filtersValues.dataInicio}
                slotProps={{
                  textField: {
                    placeholder: "DD/MM/AAAA",
                    onClick: () => setOpenDataFim(true),
                    InputProps: {
                      startAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            edge="start"
                            onClick={(e) => {
                              e.stopPropagation();
                              setOpenDataFim(true);
                            }}
                          >
                            <Calendar />
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  },
                  inputAdornment: {
                    style: { display: "none" },
                  },
                }}
              />
            </LocalizationProvider>
          </FieldContainer>

          {/* CHAMADO */}
          <FieldContainer title={"Chamado"}>
            <InputSearch
              exibIcon
              search={filtersValues.chamado}
              setSearch={(value) =>
                setFiltersValues({ ...filtersValues, chamado: value })
              }
            />
          </FieldContainer>

          {/* CHAMADOR */}
          <FieldContainer title={"Chamador"}>
            <InputSearch
              exibIcon
              search={filtersValues.chamador}
              setSearch={(value) =>
                setFiltersValues({ ...filtersValues, chamador: value })
              }
            />
          </FieldContainer>

          {/* TIPO (Select Múltiplo com Pesquisa) */}
          <FieldContainer title={"Tipo"}>
            <SelectTagV2
              valueTag={filtersValues.tipo}
              options={tiposOptions}
              onSelect={(option) => {
                const jaSelecionado = filtersValues.tipo.find(
                  (item) => item.id === option.id,
                );

                if (jaSelecionado) {
                  const novoArray = filtersValues.tipo.filter(
                    (item) => item.id !== option.id,
                  );
                  setFiltersValues({ ...filtersValues, tipo: novoArray });
                } else {
                  setFiltersValues({
                    ...filtersValues,
                    tipo: [...filtersValues.tipo, option],
                  });
                }
              }}
            />
          </FieldContainer>

          {/* PALAVRA CONTÉM */}
          <FieldContainer title={"Palavra contém"}>
            <InputSearch
              exibIcon
              search={filtersValues.palavra}
              setSearch={(value) =>
                setFiltersValues({ ...filtersValues, palavra: value })
              }
            />
          </FieldContainer>

          {/* CANAIS (Select Múltiplo com Pesquisa e Ícone) */}
          <FieldContainer title={"Canais"}>
            <SelectTagV2
              valueTag={filtersValues.canais}
              options={canaisUserOptions}
              onSelect={(option) => {
                const jaSelecionado = filtersValues.canais.find(
                  (item) => item.id === option.id,
                );

                if (jaSelecionado) {
                  const novoArray = filtersValues.canais.filter(
                    (item) => item.id !== option.id,
                  );
                  setFiltersValues({ ...filtersValues, canais: novoArray });
                } else {
                  setFiltersValues({
                    ...filtersValues,
                    canais: [...filtersValues.canais, option],
                  });
                }
              }}
              channel={true}
            />
          </FieldContainer>
        </div>
      </FilterDrawer>
      <ColumnsFilter
        columns={columnsConfig}
        setColumns={setColumnsConfig}
        modalId="modal-columns"
      />
      <DetailsVoiceModal infosContact={infosVoiceModal} />
      <HistoricAlertModal
        onCancel={() => {
          contactWithNumber(dataToStartCall, true);
          closeModal();
        }}
        onConfirm={() => {
          if (dataToStartCall.contactid) {
            openDetailsContact(dataToStartCall.contactid, dataToStartCall);
          } else {
            verifyAddUser(dataToStartCall, true);
          }
          closeModal();
        }}
      />
    </main>
  );
}

export default HistoryCalls;
